import React, { useEffect } from "react";
import { generalPostFunction } from "../Globals/globalFunctions";
import { requiredValidator } from "../Components/FormValidations";
import FormError from "../Components/FormError";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";
import { gameCollectionArray, userLevelArray } from "../Globals/globalMetaData";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { SvgIcon } from "../Components/SvgIcons";

function AccountCreation() {
	const navigate = useNavigate();
	const {
		register,
		formState: { errors },
		handleSubmit,
		reset,
		watch,
		setValue,
	} = useForm();
	const account = JSON.parse(localStorage.getItem("account"));
	const locationState = useLocation().state;
	const setAllPlayers = useSelector((state) => state.allPlayers.setAllPlayers);

	useEffect(() => {
		if (locationState) {
			switch (locationState) {
				case "/all-super-stokez":
					reset({ level: 1 });
					break;
				case "/all-stokez":
					reset({ level: 2 });
					break;
				case "/all-master":
					reset({ level: 3 });
					break;
				case "/all-agents":
					reset({ level: 4 });
					break;
				case "/all-users":
					reset({ level: 5 });
					break;
				default:
					break;
			}
		}
	}, [locationState]);

	const createNewAccount = async (data) => {
		const payload = {
			...data,
			registerstate: 1,
			level: parseInt(data.level),
			aid: watch()?.agent || null,
			mid: watch()?.master || null,
			sid: watch()?.stokez || null,
			ssid: watch()?.super_stokez || null,
			creator: account.username,
			games: JSON.stringify(watch()?.games),
			devices: JSON.stringify(watch()?.devices),
		};

		const response = await generalPostFunction("/createuser", payload, "3040");

		if (response.message) {
			toast.success("Account created successfully!");
			reset();
		} else {
			toast.error("Account creation failed");
		}
	};

	useEffect(() => {
		if (!account) return;

		if (account.level === 1) {
			setValue("super_stokez", account.username);
		}

		if (account.level === 2) {
			setValue("super_stokez", account.super_stockist_id);
			setValue("stokez", account.username);
		}

		if (account.level === 3) {
			setValue("super_stokez", account.super_stockist_id);
			setValue("stokez", account.stockist_id);
			setValue("master", account.username);
		}

		if (account.level === 4) {
			setValue("super_stokez", account.super_stockist_id);
			setValue("stokez", account.stockist_id);
			setValue("master", account.master_id);
			setValue("agent", account.username);
		}
	}, [setAllPlayers]);

	return (
		<div className="overviewTableWrapper">
			<div className="overviewTableChild">
				<div className="d-flex flex-wrap">
					<div className="col-12">
						<div className="heading">
							<div className="content">
								<h4>Account Creation</h4>
								<p>Create a new account</p>
							</div>
							<div className="buttonGroup">
								<button className="panelButton gray" onClick={() => navigate(-1)}>
									<span className="text">Back</span>
									<span className="icon">
										<SvgIcon name="back" />
									</span>
								</button>
								<button type="button" className="panelButton" onClick={handleSubmit(createNewAccount)}>
									<span className="text">Save</span>
									<span className="icon">
										<SvgIcon name="save" />
									</span>
								</button>
							</div>
						</div>
					</div>
					<div className="col-12" style={{ padding: "25px 23px" }}>
						<form className="mb-0" onSubmit={handleSubmit(createNewAccount)}>
							{account.level < 1 && watch().level > 1 ? (
								<div className="formRow col-xl-6">
									<div className="formLabel">
										<label>Select Super Stockist</label>
									</div>
									<div className="col-6">
										<select className="formItem" {...register("super_stokez", requiredValidator)}>
											<option value={""}>Select Super Stockist</option>
											{setAllPlayers
												?.filter((item) => item.level === userLevelArray.find((lvl) => lvl.name === "Super Stokist")?.level)
												?.map((item, index) => (
													<option key={index} value={item.username}>
														{item.username}
													</option>
												))}
										</select>
										{errors.super_stokez && <FormError message={errors.super_stokez.message} />}
									</div>
								</div>
							) : (
								""
							)}
							{account.level < 2 && watch().level > 2 ? (
								<div className="formRow col-xl-6">
									<div className="formLabel">
										<label>Select Stockist</label>
									</div>
									<div className="col-6">
										<select className="formItem" {...register("stokez", requiredValidator)}>
											<option value={""}>Select Stockist</option>
											{setAllPlayers
												?.filter((item) => item.level === userLevelArray.find((lvl) => lvl.name === "Stokist")?.level && item.super_stockist_id === watch().super_stokez)
												?.map((item, index) => (
													<option key={index} value={item.username}>
														{item.username}
													</option>
												))}
										</select>
										{errors.stokez && <FormError message={errors.stokez.message} />}
									</div>
								</div>
							) : (
								""
							)}
							{account.level < 3 && watch().level > 3 ? (
								<div className="formRow col-xl-6">
									<div className="formLabel">
										<label>Select Master</label>
									</div>
									<div className="col-6">
										<select className="formItem" {...register("master", requiredValidator)}>
											<option value={""}>Select Master</option>
											{setAllPlayers
												?.filter((item) => item.level === userLevelArray.find((lvl) => lvl.name === "Master")?.level && item.stockist_id === watch().stokez)
												?.map((item, index) => (
													<option key={index} value={item.username}>
														{item.username}
													</option>
												))}
										</select>
										{errors.master && <FormError message={errors.master.message} />}
									</div>
								</div>
							) : (
								""
							)}
							{account.level < 4 && watch().level > 4 ? (
								<>
									<div className="formRow col-xl-6">
										<div className="formLabel">
											<label>Select Agent</label>
										</div>
										<div className="col-6">
											<select className="formItem" {...register("agent", requiredValidator)}>
												<option value={""}>Select Agent</option>
												{setAllPlayers
													?.filter((item) => item.level === userLevelArray.find((lvl) => lvl.name === "Agent")?.level && item.master_id === watch().master)
													?.map((item, index) => (
														<option key={index} value={item.username}>
															{item.username}
														</option>
													))}
											</select>
											{errors.agent && <FormError message={errors.agent.message} />}
										</div>
									</div>
									<div className="border-top" />
								</>
							) : (
								""
							)}
							<div className="formRow col-xl-6">
								<div className="formLabel">
									<label>Username</label>
								</div>
								<div className="col-6">
									<input className="formItem" type="text" defaultValue={""} {...register("username", requiredValidator)} />
									{errors.username && <FormError message={errors.username.message} />}
								</div>
							</div>
							<div className="formRow col-xl-6">
								<div className="formLabel">
									<label>Password</label>
								</div>
								<div className="col-6">
									<input className="formItem" type="text" defaultValue={"123456"} {...register("password", requiredValidator)} />
									{errors.password && <FormError message={errors.password.message} />}
								</div>
							</div>
							<div className="formRow col-xl-6">
								<div className="formLabel">
									<label>Commission %</label>
								</div>
								<div className="col-6">
									<input className="formItem" type="number" defaultValue={5} min={0} max={100} {...register("user_commission")} />
								</div>
							</div>
							<div className="formRow col-xl-6">
								<div className="formLabel">
									<label>Balance</label>
								</div>
								<div className="col-6">
									<input className="formItem" type="number" {...register("balance")} disabled />
								</div>
							</div>
							<div className="formRow col-xl-6">
								<div className="formLabel">
									<label>Level</label>
								</div>
								<div className="col-6">
									<select className="formItem" defaultValue={4} {...register("level", requiredValidator)}>
										{userLevelArray
											.filter((item) => item.level > account.level)
											.map((item, index) => (
												<option key={index} value={item.level}>
													{item.name}
												</option>
											))}
									</select>
									{errors.level && <FormError message={errors.level.message} />}
								</div>
							</div>
							{watch().level == userLevelArray.find((item) => item.name === "User")?.level && (
								<div className="formRow col-xl-6">
									<div className="col-6">
										<div className="formLabel">
											<label className="fw-bold">Games</label>
										</div>
										<ul>
											{gameCollectionArray?.map((item) => {
												return (
													<li>
														<input type="checkbox" value={item.api} {...register("games")} /> {item.label}
													</li>
												);
											})}
										</ul>
									</div>

									<div className="col-6">
										<div className="formLabel">
											<label className="fw-bold">Device Permissions</label>
										</div>
										<ul>
											<li>
												<input type="checkbox" value="pc" {...register("devices")} /> PC
											</li>
											<li>
												<input type="checkbox" value="mobile" {...register("devices")} /> Mobile
											</li>
											<li>
												<input type="checkbox" value="both" {...register("devices")} /> Both (PC + Mobile)
											</li>
										</ul>
									</div>
								</div>
							)}
						</form>
					</div>
				</div>
			</div>
		</div>
	);
}

export default AccountCreation;
